"use strict";

define('config',{
  settings: {
    FAVORITE_ROLE: 'IRB.FAVORITE_ROLE',
    MUTE_OPTION: 'IRB.MUTE_OPTION'
  },
  usePushState: USE_PUSHSTATE,
  staticRoot: STATIC_ROOT,
  IRB_HAS_ORG_APPROVERS_NAME: 'IRB.IRB_HAS_ORG_APPROVERS',
  IRB_CITI_ENABLED_NAME: 'IRB.CITI_ENABLED',
  IRB_TIMEZONE: 'IRB.TIMEZONE',
  EXPIRABLE_DECISION_DESCRIPTIONS: ['Approved', 'Exempt', 'Rely on NCI-CIRB', 'Rely on External IRB'],
  ADMIN_CHECK_IN_DECISION_DESCRIPTIONS: ['Exempt', 'Exempt - Limited IRB', 'Rely on NCI-CIRB', 'Rely on External IRB'],
  ADMIN_CHECK_IN_PRE_2018_DECISION_DESCRIPTIONS: ['Exempt'],
  PRE_2018_POLICY: 'PRE2018RULE',
  POST_2018_POLICY: 'POST2018RULE',
  FULL_REVIEW_TYPE: 'FULL',
  EXPEDITED_REVIEW_TYPE: 'EXPEDITED',
  ADMIN_REVIEW_TYPE: 'ADMINISTRATIVE',
  LIMITED_REVIEW_TYPE: 'LIMITED',
  EXEMPT_REVIEW_TYPE: 'EXEMPT',
  dateFormat: 'L',
  timeFormat: 'LT',
  contentCss: {
    padding: '2em'
  },
  redactorDefaults: {
    minHeight: 400,
    buttons: ['formatting', 'bold', 'italic', 'underline', 'deleted', 'alignment', 'unorderedlist', 'orderedlist', 'table', 'link'],
    xhtml: true,
    linebreaks: true,
    tabFocus: false
  },
  AUTHORITY_FIELD: 'authority',
  DISTRACTION_FREE_FIELD: 'distractionFree',
  APP_NAME: 'Human Ethics',
  APP_LEGACY_NAME: 'IRB',
  ACCESS_COOKIE_NAME: 'cayuse_access',
  BOOTSTRAP_DATEPICKER_LOCALES: ['ar', 'az', 'bg', 'ca', 'cs', 'cy', 'de', 'el', 'es', 'fa', 'fi', 'fr', 'gl', 'he', 'hr', 'hu', 'id', 'is', 'it', 'ja', 'ka', 'kk', 'kr', 'lt', 'lv', 'mk', 'ms', 'nb', 'nl-BE', 'nl', 'no', 'pl', 'pt-BR', 'ro', 'rs-latin', 'rs', 'ru', 'sk', 'sl', 'sq', 'sv', 'sw', 'th', 'tr', 'ua', 'vi', 'zh-CN', 'zh-TW']
});

